<section class="login_grid">
<div class="login_logo">
    <img class="logo" src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Header/logo.png" alt="Miles Education">
</div>
<div class="lms_login">
      <div class="container-fluid">
        <div class="row login_form">
            <div class="col-sm-6">
            <div class="login_form_lft">
                <div class="login_left">
                    <img class="login_left_img" src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/all-images/statue_of_liberty_new.png" alt="Miles Education">
                </div>
            </div>
            </div>
            <div class="col-sm-6">
            <div class="login_form_rgt">
                <!-- <div class="brand_img">
                    <img class="login_left_img" src="../assets/brands.png" alt="Miles Education">
                </div> -->
                <div class="form_login">
                    <h4>Forgot Password</h4>
                    <p>With offers you won't refuse, we will help you <br>fulfil your ambitions. Let's get started!</p>
                    <form [formGroup]="fetchPassword">
                        <div style="position: relative;">
                          <img src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Login/mailIcon.svg"
                            class="left_icon">
                          <input type="text" class="form_control" name="registered_email" formControlName="registered_email"
                            placeholder="Registered email id">
                            <span class="text-danger"
                            *ngIf="(registerFormControl.registered_email.touched) && registerFormControl.registered_email.errors?.required">
                            Email is required
                        </span>
                        <span class="text-danger"
                            *ngIf="registerFormControl.registered_email.touched && registerFormControl.registered_email.errors?.email">
                            Enter a valid email address
                        </span>
                        </div>
                        <div class="btn_reset">
                            <button type="button" class="blue_btn reset_btn" (click)="submit()">Submit</button>
                        </div>  
                    </form>
                    <div class="prevoius_page">
                        <a routerLink="/login" class="forgot_pwd" style="color:  #06345B">Go Back </a>
                    </div>
                </div>
            </div>
            </div>
  
        </div>
      </div>
</div>
</section>